import { useContext } from 'react';
import { TableContext } from './TableContext';

const useSelectedRowCount = () => {
    const { table } = useContext(TableContext);
    const rowCount = table.getRowCount();
    const isAllRecordsSelected = table.getState().isAllRecordsSelected;
    const selectedRows = table.getSelectedRowModel().flatRows;

    return isAllRecordsSelected ? rowCount : selectedRows.length;
};

export { useSelectedRowCount };
